(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifOnIdleTime', swifOnIdleTime);


    /**
    * @ngdoc directive
    * @name swif.ui:swifOnIdletime
    * @module swif.ui
    * @restrict E
    * @description refresh collections when idle
    **/
    function swifOnIdleTime(swifOnIdleTimeService, collections) {
        'ngInject';
        return {
            restrict: 'E',
            scope: {
                collectionIds: '=?',
                onIdle: '&?'
            },
            link: function (scope, element, attr) {
                element.mousemove(swifOnIdleTimeService.resetIdleTime);
                element.keypress(swifOnIdleTimeService.resetIdleTime);
                if (scope.collectionIds) {
                    swifOnIdleTimeService.onIdleTimeSpent = function () {
                        _.forEach(scope.collectionIds, function (id) {
                            console.log('update collection ' + id);
                            collections.getItems(id);
                        });
                    };
                }
                if (scope.onIdle) {
                    swifOnIdleTimeService.onIdleTimeSpent = onIdle;
                }
                scope.$on('$destroy', function () {
                    swifOnIdleTimeService.onIdleTimeSpent = false;
                    element.off('mousemove');
                    element.off('keypress');
                });
            }
        };
    }

})();